import { useEffect, useState } from "react"
import type { Server } from "@mc/types"
import { listServers } from "../../api/servers.js"
import { friendlyError } from "../../api/errorMessages.js"
import { Spinner } from "../ui/Spinner.js"
import { ServerCard } from "./ServerCard.js"

type ServerListState =
  | { status: "loading" }
  | { status: "ready"; servers: Server[] }
  | { status: "error"; message: string }

export function ServerList() {
  const [state, setState] = useState<ServerListState>({ status: "loading" })

  useEffect(() => {
    let cancelled = false
    listServers()
      .then(({ servers }) => {
        if (!cancelled) setState({ status: "ready", servers })
      })
      .catch((err) => {
        if (!cancelled) setState({ status: "error", message: friendlyError(err).message })
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (state.status === "loading") {
    return (
      <div style={{ display: "grid", placeItems: "center", padding: "var(--space-12) 0" }}>
        <Spinner size="lg" />
      </div>
    )
  }

  if (state.status === "error") {
    return (
      <p role="alert" style={{ color: "var(--status-error)", fontSize: "var(--text-sm)" }}>
        {state.message}
      </p>
    )
  }

  if (state.servers.length === 0) {
    return <p style={{ color: "var(--text-muted)" }}>Todavía no tenés servidores.</p>
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        gap: "var(--space-4)",
      }}
    >
      {state.servers.map((server) => (
        <ServerCard key={server.serverId} server={server} />
      ))}
    </div>
  )
}
